"use strict";
exports.__esModule = true;
var Route_1 = require("./Route");
var tools_1 = require("./tools");
var parser_1 = require("./parser");
var Router = /** @class */ (function () {
    function Router() {
        this.regex = [];
        this.routes = [];
        this.routesByName = {};
        this.globalFilter = {};
    }
    Router.prototype.run = function (url) {
        if (url === void 0) { url = document.location.hash.substr(1); }
        var draftRouteParts = parser_1.parseUrl(url);
        var routeParts = {
            parts: {},
            queryParams: draftRouteParts.queryParams
        };
        var val = {};
        for (var i = 0; i < this.routes.length; ++i) {
            val = {};
            if (!this.routes[i].isCandidate(draftRouteParts.parts, val)) {
                val = {};
                continue;
            }
            routeParts.parts = val;
            return this.routes[i].callback.call(null, routeParts);
        }
        for (var i = 0; i < this.regex.length; ++i) {
            if (url.match(this.regex[i].url)) {
                return this.regex[i].callback.call(null, routeParts);
            }
        }
    };
    Router.prototype.registerListener = function () {
        var _this = this;
        var doRoute = function () {
            _this.run(document.location.hash.substr(1));
        };
        if ('addEventListener' in window) {
            window.addEventListener('hashchange', doRoute, false);
        }
        else {
            // @ts-ignore
            window.onhashchange = doRoute;
        }
        doRoute();
    };
    Router.prototype.url = function (routeName, routeParts, queryParams) {
        if (!(this.routesByName[routeName] instanceof Route_1.Route)) {
            throw new Error('Cannot find ' + routeName + ' url');
        }
        var urlByParts = this.routesByName[routeName].generateByRouteParts(routeParts);
        if (queryParams) {
            return tools_1.addQueryParamParts(urlByParts, queryParams).join('');
        }
        return urlByParts.join('');
    };
    Router.prototype.addFilter = function (name, callback) {
        tools_1.checkFunction(callback);
        this.globalFilter[name] = callback;
        return this;
    };
    Router.prototype.route = function (url, callback) {
        var route = new Route_1.Route(this, url, callback);
        if (url instanceof RegExp) {
            this.regex.push(route);
        }
        else {
            this.routes.push(route);
        }
        return route;
    };
    return Router;
}());
exports["default"] = Router;
//# sourceMappingURL=Router.js.map